// extracted by mini-css-extract-plugin
export default {"user-icon-wrapper":"VisitationReportsPreview_user-icon-wrapper__2jASF","transparentTable":"VisitationReportsPreview_transparentTable__1cfss"};